import clsx from 'clsx';
import { Link, Route, Switch, useLocation, useRoute } from 'wouter';
import { Workstation } from './workstation';
import { bg_color, border_color } from '../shared/colors';
import { useMachineStatus } from '../hooks/use-machine-status';
import { ResLoading } from '../shared/res-loading';

export const LinePreview = () => {
  const [, setLocation] = useLocation();
  const [, rest] = useRoute<{ workstation_id: string }>(
    '/workstations/:workstation_id',
  );
  const { data: line, isLoading, error } = useMachineStatus();

  if (!line || isLoading) return <ResLoading />;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div
      className="relative w-full p-6 bg-no-repeat bg-center bg-contain"
      onClick={() => setLocation('/')}
      style={{
        backgroundImage: `url(/line.jpeg)`,
      }}>
      {line.workcenter_info.subcenters.map((sc) => {
        const active = rest?.workstation_id === sc.sub_ws_id.toString();
        const position = JSON.parse(sc.sub_ws_position || '[]') as [
          number,
          number,
        ];
        const status = line.current.status_code;
        return (
          <Link
            key={sc.sub_ws_id}
            href={`/workstations/${sc.sub_ws_id}`}
            onClick={(e) => e.stopPropagation()}>
            <div
              className={clsx(
                'group w-[34px] h-[34px] rounded-full absolute cursor-pointer transition-transform text-center border-4 border-white',
                active ? 'scale-110' : 'hover:scale-110',
                bg_color(status),
              )}
              style={{
                left: `${position[0]}px`,
                top: `${position[1]}px`,
              }}>
              <span
                className={clsx(
                  active ? 'inline' : 'hidden group-hover:inline',
                  'absolute -top-[66px] -left-[68px] w-[160px] h-[160px] bg-opacity-10 border-4 rounded-full',
                  bg_color(status),
                  border_color(status),
                )}
              />
            </div>
          </Link>
        );
      })}
      <Switch>
        <Route path="/workstations/:workstation_id" component={Workstation} />
      </Switch>
    </div>
  );
};
